<template>
  <div class="container-dash">
    <div class="welcome-banner">
      <div class="welcome-container">
        <div class="titulo">Bienvenido {{ usuario.nombres }}</div>
      </div>
    </div>

    <!-- Selector de países completamente rediseñado -->
    <div class="country-selector-container">
      <div class="country-options-container">
        <div class="country-selector-wrapper">
          <div class="country-selector">
            <div 
              v-for="country in countries"
              :key="country.value"
              class="country-card"
              :class="{ 'is-selected': selectedCountry === country.value }"
              @click="!isLoading && changeCountry(country.value)"
            >
              <div class="country-flag">
                <img :src="country.flag" :alt="country.name">
                <div v-if="isLoading && selectedCountry === country.value" class="country-loading-indicator">
                  <v-progress-circular 
                    size="20" 
                    width="2" 
                    color="white" 
                    indeterminate
                  ></v-progress-circular>
                </div>
              </div>
              <span class="country-name">{{ country.name }}</span>
            </div>
          </div>
        </div>
        
        <!-- Botón de descargar al lado derecho -->
        <div class="download-btn-wrapper">
          <v-btn
            rounded
            elevation="2"
            class="btn-descargar"
            @click="crearPdf"
            :loading="descargarPdf"
            color="#482474"
            dark
          >
            <v-icon left> mdi-download </v-icon> Descargar informe
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Mensaje de carga elegante -->
    <v-snackbar
      v-model="showLoadingSnackbar"
      :timeout="-1"
      color="purple darken-2"
      top
      class="loading-snackbar"
    >
      <div class="d-flex align-center">
        <v-progress-circular
          indeterminate
          color="white"
          size="20"
          width="2"
          class="mr-3"
        ></v-progress-circular>
        <span>Cargando datos de {{ getCountryName(selectedCountry) }}...</span>
      </div>
    </v-snackbar>

    <div class="content">
      <Filtros :selectedCountry="selectedCountry" />
      <div v-bind:class="[descargarPdf ? 'formato-pdf' : 'graficas']">
        <img
          src="../assets/biomakers_logo.png"
          class="logo-biomakers"
          v-if="descargarPdf"
        />
        <div class="cards-total">
          <CardTotal
            :titulo="'Total muestras'"
            :icono="'muestra'"
            :url="'/total-muestras'"
            :selectedCountry="selectedCountry"
          />
          <CardTotal
            :titulo="'Clientes sponsor'"
            :icono="'cliente'"
            ref="cardSponsors"
            :url="'/total-sponsors'"
            :selectedCountry="selectedCountry"
          />
          <CardTotal
            :titulo="'Tiempo informe'"
            :textoOpcional="'*promedio'"
            :icono="'tiempo'"
            :url="'/tiempo-informe'"
            :selectedCountry="selectedCountry"
          />
        </div>
        <v-card elevation="1">
          <span class="nombre-grafica">Evolución de muestras</span>
          <hr />
          <div class="grafica">
            <EvolucionDeterminaciones :selectedCountry="selectedCountry" />
          </div>
        </v-card>
        
        <v-card elevation="1">
          <span class="nombre-grafica">Evolución de ingreso test</span>
          <hr />
          <div class="grafica">
            <EvolucionIngresoMuestras :selectedCountry="selectedCountry" />
          </div>
        </v-card>

        <v-card elevation="1">
          <span class="nombre-grafica">Evolución de tiempo de informe</span>
          <hr />
          <div class="grafica">
            <EvolucionTiempoInforme :selectedCountry="selectedCountry" />
          </div>
        </v-card>

        <div class="html2pdf__page-break"></div>

        <div class="dos-columnas">
          <v-card elevation="1">
            <span class="nombre-grafica">Determinaciones por tipo tumoral</span>
            <hr />
            <div class="grafica-columna">
              <DeterminacionesTipoTumoral :selectedCountry="selectedCountry" />
            </div>
          </v-card>

          <v-card elevation="1">
            <span class="nombre-grafica"
              >Determinaciones resueltas por país de origen</span
            >
            <hr />
            <div class="grafica-columna">
              <DeterminacionesPais :selectedCountry="selectedCountry" />
            </div>
          </v-card>
        </div>

        <v-card elevation="1">
          <span class="nombre-grafica">Tipo de resultado</span>
          <hr />
          <div class="grafica">
            <TipoResultado  :selectedCountry="selectedCountry" />
          </div>
        </v-card>

        <div class="html2pdf__page-break"></div>

        <v-card elevation="1">
          <span class="nombre-grafica">Mutaciones por tipo tumoral</span>
          <hr />
          <div class="grafica">
            <MutacionesTipoTumoral  :selectedCountry="selectedCountry" />
          </div>
        </v-card>

        <v-card elevation="1">
          <span class="nombre-grafica">Mutaciones en biomarcadores</span>
          <v-progress-circular
            v-if="cargandoDatosVariantes"
            indeterminate
            color="purple"
          ></v-progress-circular>
          <hr />
          <div class="grafica">
            <MutacionesBiomarcadores @cargandoDatos="mostrarLoader"   :selectedCountry="selectedCountry" />
          </div>
        </v-card>

        <v-card elevation="1">
          <span class="nombre-grafica">Resultados TPS y CPS para PDL1</span>
          <v-progress-circular
            v-if="cargandoDatosVariantes"
            indeterminate
            color="purple"
          ></v-progress-circular>
          <hr />
          <div class="grafica">
            <ResultPdl1 @cargandoDatos="mostrarLoader"  :selectedCountry="selectedCountry" />
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Filtros from "../components/Filtros";
import CardTotal from "../components/CardTotal";
import EvolucionDeterminaciones from "../components/Graficas/EvolucionDeterminaciones";
import EvolucionTiempoInforme from "../components/Graficas/EvolucionTiempoInforme";
import DeterminacionesPais from "../components/Graficas/DeterminacionesPais";
import EvolucionIngresoMuestras from "../components/Graficas/EvolucionIngresoMuestras";
import TipoResultado from "../components/Graficas/TipoResultado";
import MutacionesTipoTumoral from "../components/Graficas/MutacionesTipoTumoral";
import DeterminacionesTipoTumoral from "../components/Graficas/DeterminacionesTipoTumoral";
import MutacionesBiomarcadores from "../components/Graficas/MutacionesBiomarcadores.vue";
import ResultPdl1 from "../components/Graficas/ResultPdl1.vue";
import { mapState } from "vuex";
import * as html2pdf from "html2pdf.js";
export default {
  name: "Dashboard",
  components: {
    Filtros,
    CardTotal,
    EvolucionDeterminaciones,
    EvolucionTiempoInforme,
    DeterminacionesPais,
    TipoResultado,
    DeterminacionesTipoTumoral,
    MutacionesTipoTumoral,
    MutacionesBiomarcadores,
    ResultPdl1,
    EvolucionIngresoMuestras,
  },
  data() {
    return {
      descargarPdf: false,
      cargandoDatosVariantes: false,
      selectedCountry: 'argentina', // default country
      isLoading: false, // Estado para manejar la carga
      showLoadingSnackbar: false, // Control para el snackbar de carga
      countries: [
        { 
          value: 'argentina', 
          name: 'Argentina', 
          flag: 'https://flagcdn.com/w80/ar.png' 
        },
        { 
          value: 'mexico', 
          name: 'México', 
          flag: 'https://flagcdn.com/w80/mx.png' 
        },
        { 
          value: 'brasil', 
          name: 'Brasil', 
          flag: 'https://flagcdn.com/w80/br.png' 
        }
      ]
    };
  },
  watch: {
    selectedCountry() {
      // La lógica de cambio ya no se realiza directamente en el watcher
      // sino en el método changeCountry
    },
    isLoading(val) {
      // Controlar la visibilidad del snackbar basado en el estado de carga
      this.showLoadingSnackbar = val;
    }
  },
  computed: {
    ...mapState(["filtros", "usuario"]),
  },
  methods: {
    // Método para obtener el nombre del país por su valor
    getCountryName(value) {
      const country = this.countries.find(c => c.value === value);
      return country ? country.name : value;
    },
    // Nuevo método para cambiar el país con mejor manejo
    changeCountry(countryValue) {
      if (this.selectedCountry === countryValue || this.isLoading) return;
      
      this.selectedCountry = countryValue;
      this.isLoading = true;
      
      // Actualizar el país en el store
      this.$store.commit('setSelectedCountry', countryValue);
      
      // Inicializar los datos para el nuevo país
      this.$store.dispatch('inicializarFechaDesde')
        .catch(error => {
          console.error('Error al cargar datos para el país:', countryValue, error);
        })
        .finally(() => {
          // Reactivar interacción después de un tiempo mínimo
          setTimeout(() => {
            this.isLoading = false;
          }, 800); // Un poco más de tiempo para una mejor experiencia
        });
    },
    mostrarLoader(valor) {
      this.cargandoDatosVariantes = valor;
    },
    crearPdf() {
      this.descargarPdf = true;
      const $elementoParaConvertir = document.querySelector(".graficas");
      html2pdf()
        .set({
          margin: 0,
          filename: "reporte_dashboard.pdf",
          image: {
            type: "jpeg",
            quality: 0.98,
          },
          html2canvas: {
            scale: 3,
            letterRendering: true,
          },
          jsPDF: {
            unit: "in",
            format: "a3",
            orientation: "portrait",
          },
        })
        .from($elementoParaConvertir)
        .save()
        .then(() => {
          this.descargarPdf = false;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style scoped>
.cards-total {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1em;
  width: 100%;
}

.container-dash {
  margin: 4rem 0 1em;
}

.content {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: 22% 76%;
  gap: 1.5rem;
}

.dos-columnas {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.grafica {
  width: 96%;
  height: fit-content;
  margin: 1.5rem;
}

.grafica-columna {
  width: 92%;
  height: fit-content;
  margin: 1rem;
}

.graficas,
.formato-pdf {
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
}

.formato-pdf {
  background-color: #fcfaff;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI2MDciIHZpZXdCb3g9IjAgMCAxNDQwIDYwNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNjA3VjBIMTQ0MVYzMTguNUwxMDE5LjQxIDU0NkwwIDYwN1oiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9Ii0wLjUwMDcwNCIgeTE9IjM0MC41IiB4Mj0iMTQ0MS41IiB5Mj0iMzM3LjQ5MSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjM0YyNTYyIi8+CjxzdG9wIG9mZnNldD0iMC4zMzMzMzMiIHN0b3AtY29sb3I9IiM0QzI3ODMiLz4KPHN0b3Agb2Zmc2V0PSIwLjY2MTQ1OCIgc3RvcC1jb2xvcj0iIzY3NDc5NiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5RTg4QkUiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding: 2em;
}
.logo-biomakers {
  width: 200px;
}

.nombre-grafica {
  font-weight: 600;
  font-size: 18px;
  padding: 1.5rem;
  display: inline-block;
}

.welcome-banner {
  background-color: #482474;
  width: 100%;
  padding: 10px 0;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(72, 36, 116, 0.3);
}

.welcome-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.titulo {
  font-size: 24px;
  color: white;
  font-weight: 600;
  text-align: center;
  background-color: transparent;
  padding: 8px 20px;
  box-shadow: none;
}

.top {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  position: relative;
}

.country-selector-container {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.country-options-container {
  display: grid;
  grid-template-columns: 1fr auto;
  width: 100%;
  max-width: 900px;
  margin: 0 auto 1rem auto;
  align-items: center;
  padding: 0 20px;
}

.country-selector-wrapper {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.country-selector {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 0;
  width: 100%;
}

.download-btn-wrapper {
  padding-left: 20px;
}

.country-card {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 10px 10px;
  border-radius: 8px;
  border: 2px solid #ddd;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: white;
  justify-content: center;
  margin: 0;
}

.country-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  border-color: #6e4c9f;
}

.country-card.is-selected {
  background-color: #482474;
  color: white;
  border-color: #482474;
  box-shadow: 0 4px 12px rgba(72, 36, 116, 0.3);
}

.country-card.is-selected .country-name {
  color: white;
  font-weight: 600;
}

.country-card[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.country-loading {
  opacity: 0.5;
  pointer-events: none;
}

.country-flag {
  display: flex;
  align-items: center;
  margin-right: 1rem;
  position: relative;
}

.country-flag img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 0.5rem;
}

.country-loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loading-snackbar {
  padding: 1rem;
  font-size: 16px;
  font-weight: 600;
}

.download-container {
  display: none;
}

.btn-descargar {
  font-weight: 600;
  font-size: 16px;
  text-transform: none;
  padding: 8px 20px;
  white-space: nowrap;
}

.selector-header, .selector-title-wrapper, .country-selector-title {
  display: none;
}
</style>